export default __webpack_public_path__ + "static/media/equal.f700373c.svg";